import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { Info } from "@/assets/icons/icons";
import { Tooltip } from "@/components/Interface/Tooltip/Tooltip";

export const FreeEsimTrialTooltip = ({
  iconClassName,
  leftOnMobile = false,
}: {
  iconClassName?: string;
  leftOnMobile?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      leftOnMobile={leftOnMobile}
      position="bottom"
      className="right mt-4 min-w-[250px] !px-6 !py-4 text-left text-base font-normal text-black xsPlus:min-w-[327px]"
      content={
        <>
          <span className="block pb-2 text-lg font-semibold text-primary-100">
            {t(
              "translation:Onboarding.sections.rate-selection.esimTooltip.title",
            )}
          </span>
          <p className="pb-2">
            {t(
              "translation:Onboarding.sections.rate-selection.esimTooltip.description",
            )}
          </p>
          <ul className="list-disc pl-4">
            <li>
              {t(
                "translation:Onboarding.sections.rate-selection.esimTooltip.swissAddress",
              )}
            </li>
            <li>
              {t(
                "translation:Onboarding.sections.rate-selection.esimTooltip.newCustomer",
              )}
            </li>
            <li>
              {t(
                "translation:Onboarding.sections.rate-selection.esimTooltip.identification",
              )}
            </li>
          </ul>
        </>
      }
    >
      <Info
        className={clsx("h-[21px] w-[21px] text-primary-100", iconClassName)}
      />
    </Tooltip>
  );
};
